export default __webpack_public_path__ + "static/media/bathtits.883bbb3e.jpg";